import { useEffect, useState } from 'react';
import './App.css';
import myself from './img/myself.jpg';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') {
        setMenuOpen(false);
      }
    };

    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, []);

  return (
    <div className="App">
      <header className="siteHeader">
        <button
          className="menuButton"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="site-menu"
          aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          onClick={() => setMenuOpen((isOpen) => !isOpen)}
        >
          <span />
          <span />
          <span />
        </button>
      </header>

      <nav id="site-menu" className={`menuPanel ${menuOpen ? 'menuPanelOpen' : ''}`} aria-label="Main navigation">
        <button className="closeButton" type="button" onClick={() => setMenuOpen(false)}>
          Close
        </button>
        <ul>
          <li><a href="#about" onClick={() => setMenuOpen(false)}>about me</a></li>
          <li><a href="https://www.linkedin.com/in/ebding/" onClick={() => setMenuOpen(false)}>linkedin</a></li>
          <li><a href="https://medium.com/@ericbding" onClick={() => setMenuOpen(false)}>my writing</a></li>
          <li><a href="https://www.instagram.com/kale.andchicken/" onClick={() => setMenuOpen(false)}>photography</a></li>
          <li><a href="https://www.youtube.com/channel/UCo5aawBt6RBmeEJ3uBdSm3A" onClick={() => setMenuOpen(false)}>films</a></li>
        </ul>
      </nav>
      <main id="about" className='intro'>
        <div className='childBox'>
          <h1>hello world! I'm Eric Ding</h1>
          I'm a <b>senior software engineer</b> who enjoys building meaningful product experiences for users across the full stack of
          backend, frontend, and infrastructure.
        </div>
        <div className='childBox'>
          <img src={myself} alt='picture of me :p'/>
        </div>
      </main>
    </div>
  );
}

export default App;
